import { API } from '@strapi/client';

import { web3Api } from 'store/queries';

import { TopBanner, TopBannerResponse } from '../types';
import { strapiClient } from '../client';

type Response = API.DocumentResponseCollection<TopBannerResponse>;

// The endpoint name is listed in endpointsSerializedByParams constant
// in packages/protocol/src/store/queries/index.ts file.
// If the name has changed it should be reflected there as well.
export const {
  endpoints: { fetchTopBanners },
  useFetchTopBannersQuery,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    fetchTopBanners: build.query<TopBanner[], void>({
      queryFn: async () => {
        const bannersCollection = strapiClient.collection(
          'api/web3-api-top-banners',
        );

        const { data } = (await bannersCollection.find({
          sort: 'priority:desc',
        })) as Response;

        return { data };
      },
    }),
  }),
  overrideExisting: true,
});
